import check from '../libraries/check-types-ext';
export default class ProductGroup {
    constructor(groupNode, productMapper, rootProduct) {
        check.object.orFail(groupNode, 'groupNode');
        check.object.orFail(productMapper, 'productMapper');
        check.object.orFail(rootProduct, 'rootProduct');
        Object.assign(this, groupNode);
        this.products = groupNode.products.map((productNode) => {
            var _a, _b, _c, _d, _e;
            productMapper.registerCorrespondingRootProductRelationship(productNode.id || productNode.id_ref, rootProduct.id);
            const p = productMapper.getProductObject(productNode, (_a = groupNode.options) === null || _a === void 0 ? void 0 : _a.context);
            const groupContextPrice = (_b = p.pricesMap) === null || _b === void 0 ? void 0 : _b[(_c = groupNode.options) === null || _c === void 0 ? void 0 : _c.context];
            const groupContextOnlinePos = (_d = p.onlinePosMap) === null || _d === void 0 ? void 0 : _d[(_e = groupNode.options) === null || _e === void 0 ? void 0 : _e.context];
            if (groupContextPrice) {
                p.price = 0;
                p.priceStructure = {
                    defaultPrice: 0,
                    priceInGroup: groupContextPrice,
                };
            }
            if (groupContextOnlinePos) {
                p.foreignIds = groupContextOnlinePos.foreignIds;
                p.foreignNames = groupContextOnlinePos.foreignNames;
            }
            if (p.productGroupDetails === undefined) {
                p.productGroupDetails = {};
            }
            if (p.productGroupDetails[groupNode.id] === undefined) {
                p.productGroupDetails[groupNode.id] = {};
            }
            const productGroupDetails = p.productGroupDetails[groupNode.id];
            const productPriceInGroup = parseFloat(productNode.productPriceInGroup);
            if (!isNaN(productPriceInGroup)) {
                p.price = parseFloat(productNode.productPriceInGroup);
                productGroupDetails.productPriceInGroup = productPriceInGroup;
            }
            if (productNode.additionalDetails) {
                productGroupDetails.additionalDetails = productNode.additionalDetails;
            }
            return p;
        });
    }
}
